<app-header
  titleClass="is-size-3"
  subtitleClass="is-size-5"
  header="createTenant.title"
  subHeader="createTenant.subtitle"
></app-header>

<article
  [formGroup]="form"
  class="is-fullwidth box is-flex is-flex-direction-column is-align-items-center mt-5 px-5"
>
  <div class="field is-flex is-fullwidth is-flex-direction-column p-5">
    <fino-select
      [items]="modes"
      formControlName="mode"
      class="field"
      label="createTenant.mode"
      bindLabel="label"
      bindValue="value"
    >
      <div *select-item="let item">
        <div>{{ item.label | translate }}</div>
      </div>
    </fino-select>

    <fino-select
      [items]="parents"
      formControlName="parent"
      class="field"
      label="createTenant.parent"
      bindLabel="label"
      bindValue="value"
    >
      <div *select-item="let item">
        <div>{{ item.label | translate }}</div>
      </div>
    </fino-select>

    <fino-input
      formControlName="tenant"
      class="field"
      label="createTenant.tenant"
      inputAutocompleteOff
      validationIndicator
    ></fino-input>

    <fino-input
      formControlName="name"
      class="field"
      label="createTenant.name"
      inputAutocompleteOff
      validationIndicator
    ></fino-input>

    <button fino-button (click)="selectLogo()" class="mb-4">
      <fino-icon icon="Cloud Image" class="icon"></fino-icon>
      <span translate="createTenant.logo"></span>
    </button>

    <fino-input
      formControlName="bankCode"
      class="field"
      label="createTenant.bankCode"
      inputAutocompleteOff
      validationIndicator
    ></fino-input>

    <fino-input
      formControlName="rzbk"
      class="field"
      label="createTenant.rzbk"
      inputAutocompleteOff
      validationIndicator
    ></fino-input>

    <fino-input
      formControlName="bic"
      class="field"
      label="createTenant.bic"
      inputAutocompleteOff
      validationIndicator
    ></fino-input>

    <fino-input
      formControlName="initialContact"
      class="field"
      label="createTenant.initialContact"
      inputAutocompleteOff
      validationIndicator
    ></fino-input>

    @if (form.value.mode !== 'KWS') {
      <fino-checkbox
        formControlName="showArchivingSection"
        class="field"
        label="createTenant.showArchivingSection"
      ></fino-checkbox>
    }

    <button
      fino-button
      primary
      (click)="submit()"
      [loading]="!loadingSub.closed"
      translate="createTenant.submit"
    ></button>
  </div>
</article>
